<template>
  <div class="input">
    <div class="input-label">国</div>
    <div class="input-group">
      <input-select
        :option="country"
        :options="countries"
        @select="(o) => country = o" />
    </div>
  </div>
</template>

<script>
import InputSelect from '@/components/Input/Select'

export default {
  components: {
    InputSelect,
  },

  created: function () {
    this.$store.dispatch('country/retrieveCountries')
  },

  computed: {
    countries: function () {
      return this.$store.getters['country/countries']
    },

    country: {
      get: function () {
        return this.$store.state.user.country
      },
      set: function (value) {
        this.$store.commit('user/setCountry', value)
        this.$store.dispatch('country/retrievePrefectures', value)
      }
    }
  }
}
</script>


<style lang="scss" scoped>
@import '@/styles/_form.scss';
.select-suit {
  @include input-select
  width: 30%;

  &-frame {
    @include input-select-frame;
  }

  &-option {
    @include input-select-option;
  }
}
</style>
